import { render, staticRenderFns } from "./SetupPrice.vue?vue&type=template&id=6089ac0d&"
import script from "./SetupPrice.vue?vue&type=script&lang=js&"
export * from "./SetupPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports